import React from "react";
import ProFeatures from "../../billing/pro-features";

const ProFeaturesSection = ({ yearlyPrice }) => {
    return (
        <div className="account-price">
            <i className="ui_pro-accounts plan-pro font-xlarge" />
            <h1 className="font-xxlarge font-bold margin-b-l">NounPro</h1>
            <div className="price">
                {yearlyPrice === 39.99 ? (
                    <div className="price-sign-style">
                        <div className="price-dollar-sign">$</div>
                        <div className="price-dollars-bold">39</div>
                        <div className="price-cents-underline price-pro">
                            99
                        </div>
                        <div className="price-stacked-type">billed yearly</div>
                    </div>
                ) : (
                    <div>${yearlyPrice} billed yearly</div>
                )}
            </div>
            <ProFeatures />
        </div>
    );
};

export default ProFeaturesSection;
